/* eslint-disable jsx-a11y/anchor-is-valid */
import {KTableProvider} from '../../../../../../contexts/KTableProvider'
import {TableUser} from './columns'
const TableProfileWrapper = () => {
  return (
    <KTableProvider>
      <TableUser />
    </KTableProvider>
  )
}

export {TableProfileWrapper}
